export enum RecruiterActionRoutes {
    HR_REPORT_CARD = `/hr-report-card`,
    HR_SHORTLISTS = "/hr-shortlists",
    HR_SEARCH_APPEARANCES = "/search-appearances",
    HR_VIEWS = "/hr-views",
    HR_REPORT_CARD_FULL = `/recruiter-actions/hr-report-card`,
    HR_SHORTLISTS_FULL = "/recruiter-actions/hr-shortlists",
    HR_SEARCH_APPEARANCES_FULL = "/recruiter-actions/search-appearances",
    HR_VIEWS_FULL = "/recruiter-actions/hr-views",
}
